import type { ComponentType } from 'react';

import type { PlayerStore } from '@iconik-io/unified-player-core';
import { useBasePlayerContext } from '@iconik-io/unified-player-ui-react';

export type UnifiedPlayerStore = {
  playerStore: PlayerStore;
};

export function withPlayerContext<T extends UnifiedPlayerStore>(
  Component: ComponentType<T>,
) {
  return function WrappedComponent(props: Omit<T, keyof UnifiedPlayerStore>) {
    const { store } = useBasePlayerContext();
    return <Component {...(props as T)} playerStore={store} />;
  };
}
